// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import TabRouter from '@westfieldcorp/tab-router';
import noMediaPicture from '../../../img/no_medias.png';

import type { MediaGallery } from '../../../types/keepeekType';
import {
  OFFICE_MEDIA_BROCHURES,
  OFFICE_MEDIA_LOGO,
  OFFICE_MEDIA_PICTURE,
  OFFICE_MEDIA_VIDEO,
  OFFICE_MEDIA_VISIT,
} from '../../../path/officePath';
import MallMediaGallery from '../../mall/media/MallMediaGallery';
import {
  brochuresGalleries,
  layoutGalleries,
  pictureGalleries,
  videoGalleries,
  virtualVisitsGalleries,
} from '../../../const';
import { parseUrl } from '../../../utils/urlUtils';
import type { Office } from '../../../types/OfficesType';
import { galleriesHaveMedias } from '../../../utils/keepeekUtils';
import NoElementFound from '../../../components/NoElementFound';

type Props = {
  location: Location,
  officesMedias: MediaGallery[],
  office: Office,
  history: History,
}

function OfficeMedia({
  location, officesMedias, office, history,
}: Props) {
  const params = parseUrl(location.search);
  const { buildingId } = params;
  const buildingMedias = officesMedias
    .filter(buildingMedia => !buildingId || buildingMedia.buildingId.toString() === buildingId)[0];

  if (!buildingId || !buildingMedias || !buildingMedias.galleries) {
    return (
      <NoElementFound text={<Translate value="mallData.MEDIA.NO_MEDIA" />}>
        <div key="key3" className="text">
          <Translate value="mallData.MEDIA.SELECTBUILDING" />
        </div>
      </NoElementFound>
    );
  }
  if (!buildingId && officesMedias && office) {
    return (
      <div className="buildings-media-shortcuts">
        {officesMedias.map(building => (
          <div
            key={building.buildingId}
            className="building-button keepeek-image-container"
            onClick={() => history.push(`${location.pathname}?office=${params.office}&buildingId=${building.buildingId}`)}
          >
            <div className="hover-show-title-media">
              {/* the filter used in this block gets only the building (unique id) corresponding to the */}
              {/* page displayed. That's why in this block we use [0] to get the building object */}
              {this.props.office.buildingList && this.props.office.buildingList.filter(bld => building.buildingId === bld.buildingId)[0] &&
              <>
                <img
                  className="keepeek-picture"
                  alt={this.props.office.buildingList.filter(bld => building.buildingId === bld.buildingId)[0].title}
                  src={building.galleries[0] ? building.galleries[0].medias[0].thumbnail : noMediaPicture}
                />
                <span>{this.props.office.buildingList.filter(bld => building.buildingId === bld.buildingId)[0].title}</span>
              </>
              }
            </div>
          </div>
        ))}
      </div>
    );
  }
  const tabs = [];
  if (galleriesHaveMedias(layoutGalleries, buildingMedias.galleries)) {
    tabs.push({
      link: OFFICE_MEDIA_LOGO,
      label: <Translate value="mallData.MEDIA.LOGO" />,
    });
  }
  if (galleriesHaveMedias(pictureGalleries, buildingMedias.galleries)) {
    tabs.push({
      link: OFFICE_MEDIA_PICTURE,
      label: <Translate value="mallData.MEDIA.PICTURES" />,
    });
  }
  if (galleriesHaveMedias(brochuresGalleries, buildingMedias.galleries)) {
    tabs.push({
      link: OFFICE_MEDIA_BROCHURES,
      label: <Translate value="mallData.MEDIA.BROCHURES" />,
    });
  }
  if (galleriesHaveMedias(videoGalleries, buildingMedias.galleries)) {
    tabs.push({
      link: OFFICE_MEDIA_VIDEO,
      label: <Translate value="mallData.MEDIA.VIDEO" />,
    });
  }
  if (galleriesHaveMedias(virtualVisitsGalleries, buildingMedias.galleries)) {
    tabs.push({
      link: OFFICE_MEDIA_VISIT,
      label: <Translate value="mallData.MEDIA.VIRTUAL_VISITS" />,
    });
  }

  return (
    <TabRouter
      className="office-media-header"
      titleClassName="office-media-subtitle"
      underline
      tabs={tabs}
      router={
        <Switch>
          <Route
            path={OFFICE_MEDIA_PICTURE}
            render={() =>
              (<MallMediaGallery
                galleries={buildingMedias.galleries
                  .filter(gallery => pictureGalleries.includes(gallery.gallery))}
              />)
            }
          />
          <Route
            path={OFFICE_MEDIA_LOGO}
            render={() =>
              (<MallMediaGallery
                galleries={buildingMedias.galleries
                  .filter(gallery => layoutGalleries.includes(gallery.gallery))}
              />)
            }
          />
          <Route
            path={OFFICE_MEDIA_BROCHURES}
            render={() =>
              (<MallMediaGallery
                galleries={buildingMedias.galleries
                  .filter(gallery => brochuresGalleries.includes(gallery.gallery))}
              />)
            }
          />
          <Route
            path={OFFICE_MEDIA_VIDEO}
            render={() =>
              (<MallMediaGallery
                galleries={buildingMedias.galleries
                  .filter(gallery => videoGalleries.includes(gallery.gallery))}
              />)
            }
          />
          <Route
            path={OFFICE_MEDIA_VISIT}
            render={() =>
              (<MallMediaGallery
                galleries={buildingMedias.galleries
                  .filter(gallery => virtualVisitsGalleries.includes(gallery.gallery))}
              />)
            }
          />
          <Route
            path="*"
            render={() =>
              (<MallMediaGallery
                galleries={buildingMedias.galleries
                  .filter(gallery => pictureGalleries.includes(gallery.gallery))}
              />)
            }
          />
        </Switch>
      }
    />
  );
}

export default withRouter(connect(state => ({
  officesMedias: state.office.officesMedias,
}))(OfficeMedia));
